import CryptoJS from 'crypto-js'

// 加密函数
export function encrypt(text, key) {
  const iv = CryptoJS.lib.WordArray.random(16) // 生成随机IV
  const encrypted = CryptoJS.AES.encrypt(text, CryptoJS.enc.Hex.parse(key), {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  return `${iv.toString(CryptoJS.enc.Hex)}:${encrypted.ciphertext.toString(CryptoJS.enc.Hex)}`
}

// 解密函数
export function decrypt(encryptedData, key) {
  const textParts = encryptedData.split(':')
  if (textParts.length < 2) return ''
  const iv = CryptoJS.enc.Hex.parse(textParts[0])
  const ciphertext = CryptoJS.enc.Hex.parse(textParts[1])
  const decrypted = CryptoJS.AES.decrypt({ ciphertext }, CryptoJS.enc.Hex.parse(key), {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })

  return decrypted.toString(CryptoJS.enc.Utf8)
}

// 获取32字节的key
export function getRandomKey() {
  return CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Hex)
}

export function getMatchEncryptedKey(match_id: string) {
  return JSON.parse(localStorage.getItem('matchesKeys') || '{}')?.[match_id]
}

export function setMatchEncryptedKey(match_id: string, key: string) {
  const keyMap = JSON.parse(localStorage.getItem('matchesKeys') || '{}')
  keyMap[match_id] = key
  localStorage.setItem('matchesKeys', JSON.stringify(keyMap))
}
